<template lang="pug">
modal(:max-width="800", v-if="contrato")
	.card.text-left
		.card-header
			span.fa.fa-edit.mr-2
			| Firmar contrato
			button.close(@click="cerrar") &times;
		.card-body(v-if="fase === 1")
			h4 Cláusulas
			div(v-html="contrato.EmpresaTextoContratos")
		.card-body(v-if="fase === 2")
			h4 Protección de datos
			div(v-html="contrato.EmpresaProteccionDeDatos")
		.card-body.text-center(v-if="fase === 3")
			div.text-left(style="max-width:350px;display:inline-block;")
				h5 En representación de <b>{{contrato.ClienteNombre}}</b>
				Firma(@firma="setFirma($event)", ref="firma")
				br
				b {{contrato.ClienteRepresentante}}
				div(style="text-align:center;position:relative;display:block;")
					.input-group
						.input-group-prepend.input-group-append
							.input-group-text DNI
						input.form-control(v-model="DNI", placeholder="XXXXXXXXXX", :class="(DNIValido) ? '' : 'has-error'")
						.input-group-append(v-if="!DNIValido")
							button.btn.btn-danger
								span.fa.fa-exclamation-triangle
						.input-group-append(v-else)
							button.btn.btn-success
								span.fa.fa-check
		.card-footer
			.row
				.col.text-left
					button.btn.btn-primary(@click="anterior()", v-if="fase > 1")
						span.fa.fa-caret-left.mr-2
						| Anterior
				.col.text-center(v-if="fase === 3")
					button.btn.btn-warning(@click="firmar()", :disabled="firmando || !DNIValido")
						span(v-if="!firmando")
							span.fa.fa-pencil.mr-2
							| Firmar
						span(v-else)
							span.fa.fa-clock-o.mr-2
							| Firmando
				.col.text-right
					button.btn.btn-primary(@click="siguiente()", v-if="fase < 3")
						| Siguiente
						span.fa.fa-caret-right.ml-2
					button.btn.btn-danger(@click="reset()", v-if="fase === 3")
						span.fa.fa-trash.mr-2
						| Borrar firma
</template>

<script>
import Firma from './firmar'
import ValidaNIF from '../../services/validaNIF'
export default {
	props: ['contrato'],
	components: {
		Firma
	},
	data () {
		return {
			fase: 1,
			DNI: '',
			firmando: false
		}
	},
	computed: {
		DNIValido () {
			return ValidaNIF(this.DNI)
		}
	},
	methods: {
		cerrar () {
			this.$emit('cerrar')
		},
		siguiente () {
			this.fase++
		},
		anterior () {
			this.fase--
		},
		reset () {
			this.$refs.firma.reset()
		},
		firmar () {
			this.$refs.firma.firmar()
		},
		setFirma (ev) {
			if ('geolocation' in navigator) {
				navigator.geolocation.getCurrentPosition(position => {
					if (position.coords.latitude && position.coords.longitude) {
						console.log('Posición: ')
						console.log(position)

						const form = {
							firmaCliente: ev,
							DNI: this.DNI,
							lat: position.coords.latitude,
							long: position.coords.longitude,
							accuracy: position.coords.accuracy
						}

						this.firmando = true

						this.$http.post('mis-contratos/php/api/firmar-contrato.php?ContratoID=' + this.contrato.ContratoID, form, {
							responseType: 'arraybuffer',
							headers: {
								'Content-type': 'application/json',
								'Accept': 'application/pdf'
							}
						})
							.then(res => {
								this.$emit('firmado')
							})
							.catch(e => {
								console.error(e)
								this.$responseError(e)
								this.firmando = false
							})
					} else {
						this.$error('Es necesaria la geolocalización para la firma manuscrita')
					}
				}, () => {
					this.$error('Error', 'Es necesaria la geolocalización para la firma manuscrita')
				})
			} else {
				this.$error('Es necesaria la geolocalización para la firma manuscrita')
			}
		}
	}
}
</script>

<style scoped>
input.has-error {
	border: 1px solid darkred;
	background-color: #FFD9D1;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/visor-contrato/modalFirma.vue